import React from 'react';
import styled from '@benzinga/themetron';

interface Props {
  body: string;
  isAmp?: boolean;
}

interface ArticleBodyContentProps {
  isBot?: boolean;
  isPaywalled?: boolean;
  isSponsored?: boolean;
  children: React.ReactNode;
}

export const ArticleBody = ({ body }: Props) => (
  <ArticleBodyDiv
    className="article-content-body-only"
    dangerouslySetInnerHTML={{ __html: body }}
    id="article-body"
    itemProp="articleBody"
    itemScope
    itemType="https://schema.org/Article"
  />
);

export const ArticleBodyContent = ({ children, isBot, isPaywalled, isSponsored }: ArticleBodyContentProps) => {
  return (
    <ArticleBodyDiv
      className={`article-content-body-only ${
        !isBot && !isSponsored && isPaywalled ? 'article-content-paywalled' : ''
      }`}
      id="article-body"
      itemProp="articleBody"
      itemScope
      itemType="https://schema.org/Article"
    >
      {children}
    </ArticleBodyDiv>
  );
};

const ArticleBodyDiv = styled.div`
  &.article-content-body-only {
    font-family: 'Helvetica Neue', Helvetica, OpenSans, Arial, sans-serif;
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 1.2rem;

    .bz-campaign {
      a {
        font-weight: bold;
      }

      p {
        margin-bottom: unset;
      }

      .banner-link {
        .banner {
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #ceddf2;
          padding: 16px 20px 16px 20px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          gap: 8px;
          max-width: 720px;
          width: 100%;
          margin: 0 auto 40px;
          position: relative;
          overflow: hidden;
        }
      }
    }

    p,
    .core-image {
      margin-bottom: 1.2rem;
    }

    ul,
    ol {
      display: block;
      list-style: disc outside none;
      margin: 1em 0;
      padding: 0 0 0 40px;
    }
    ol {
      list-style-type: decimal;
    }

    table {
      display: inline-table;
      font-size: ${({ theme }) => theme.fontSize.base};
      margin-bottom: 1rem;

      thead {
        &:nth-child(1) {
          > tr {
            font-weight: ${({ theme }) => theme.fontWeight.semibold};
          }
        }
      }

      tbody {
        > tr {
          height: 30px;

          &:nth-of-type(odd) {
            background-color: #ffffff;
          }

          &:nth-of-type(even) {
            background-color: #f9f9fa;
          }
        }
      }
    }
  }
  &.article-content-paywalled {
    .wp-block-table,
    .wp-block-image,
    .core-block,
    .editor-paragraph {
      filter: blur(10px);
      user-select: none;
      pointer-events: none;
    }

    .editor-paragraph {
      .core-block {
        filter: unset;
      }
    }
  }
`;
